import { PageHeaderMeta } from '@/components/PageHeaderMeta/PageHeaderMeta';
import { useAppSelector } from '@/redux/hooks';
import { getBaseUrl } from '@/redux/modules/config';
import { getItemSummaryTitle } from '@/redux/modules/item/summary/itemSummary.selectors';
import { getItemDetailDescription } from '@/redux/modules/itemDetail';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';
import { safelyEscapeText } from '@/utils/safelyRender';

type Props = { itemId: number };

export const SimilarPageHeaderMeta = ({ itemId }: Props) => {
    const formatMessage = useAppFormatMessage();
    const baseUrl = useAppSelector((state) => getBaseUrl(state));
    const detailDescription = useAppSelector((state) => getItemDetailDescription(state, itemId));
    const summaryTitle = useAppSelector((state) => getItemSummaryTitle(state, itemId));
    const source = (detailDescription || summaryTitle).trim();
    const tabTitle = String(
        formatMessage(['similarPage', 'similarItemsMetaTitle'], {
            values: {
                itemName: source ? safelyEscapeText(source) : '',
            },
        })
    );

    return (
        <PageHeaderMeta
            canonical={`${baseUrl}/similar/${itemId}`}
            description={tabTitle}
            title={tabTitle}
        >
            <meta
                content="noindex, follow"
                name="robots"
            />
        </PageHeaderMeta>
    );
};
